module.exports = __webpack_public_path__ + "img/ico_position_content.8effa2f6.svg";